/*
<v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('topgymexperience')">TopGym Experience</v-chip>
                    <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('opengym')">Open Gym</v-chip>
                    <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('corsi')">Sala Corsi</v-chip>
                    <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('onetoone')">One-to-One</v-chip>
                    <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('gym')">Ginnastica e Corpo Libero</v-chip>
                    <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('vacu')">Vacu</v-chip>
 */

// Import interface from models
import {type OptionItem, type ProductType, SeatsType} from './models';

// Define types for product types
export type ProductTypeKey = 'mixed' | 'distinct' | 'video'

// Define the product type object with string literal types
export const productType: Record<ProductTypeKey, ProductType> = {
    mixed: 'mixed',
    distinct: 'distinct',
    video: 'video',
}

// Define types for seats types

// Define product type options with proper typing
export const productTypeOptions: OptionItem[] = [
    { title: 'Video lezioni', abbrev: 'Video', value: productType.video, color: '#E91E63' },
    { title: 'Sedute miste', abbrev: 'Miste', value: productType.mixed, color: '#7CB342' },
    { title: 'Sedute separate', abbrev: 'Separate', value: productType.distinct, color: '#1E88E5' },
]

// Define seats types options with proper typing
export const seatsTypesOptions: OptionItem[] = [
    { title: 'Top Gym Experience', abbrev: 'Top Gym Exp.', value: SeatsType.exp, color: '#F4511E' },
    { title: 'Open Gym', abbrev: 'Open Gym', value: SeatsType.opengym, color: '#7CB342' },
    { title: 'Sala Corsi', abbrev: 'Sala Corsi', value: SeatsType.corsi, color: '#1E88E5' },
    { title: 'Bike indoor', abbrev: 'Bike', value: SeatsType.gym, color: '#673AB7' },
    { title: 'Vacu', abbrev: 'Vacu', value: SeatsType.vacu, color: '#E91E63' },
]

export const iva = 22
export const paymentMethods: OptionItem[] = [
    { title: "Pagamento online", value: "online" },
    { title: "Pagamento in palestra", value: "manual" },
]
export const roles: OptionItem[] = [
    { title: "Cliente", value: "user" },
    { title: "Staff Viewer", value: "viewer" },
    { title: "Editor", value: "editor" },
    { title: "Amministratore", value: "admin" },
]
export const mediatypes: OptionItem[] = [
    { title: "Icona", value: "icon" },
    { title: "Copertina (Immagine)", value: "cover" },
    { title: "Banner", value: "banner" },
    { title: "Galleria", value: "gallery" },
    { title: "Audio", value: "audio" },
    { title: "Video", value: "video" },
]
export const sectionTypes: OptionItem[] = [
    { title: "Custom", value: "custom" },
    { title: "Genere", value: "genre" },
    { title: "Categoria", value: "category" },
    { title: "Allenamenti in corso", value: "resume" },
    { title: "Pacchetti in possesso", value: "mykits" },
]

export const cartStatusOptions: OptionItem[] = [
    { title: "Ordine aperto", value: "draft" },
    { title: "Ordine pagato (in attesa di spedizione)", value: "paid" },
    { title: "Ordine chiuso", value: "closed" },
]